document.addEventListener("DOMContentLoaded", function() {
    var tabs = document.querySelectorAll('.tab-link');
    tabs.forEach(function(tab) {
        tab.addEventListener('click', function() {
            var tabId = this.getAttribute('data-tab');
            tabs.forEach(function(t) { t.classList.remove('current'); });
            document.querySelectorAll('.tab-content').forEach(function(tc) {
                tc.classList.remove('current');
            });
            this.classList.add('current');
            document.getElementById(tabId).classList.add('current');
        });
    });
});
